<template lang="pug">
div
  button.change-button(
    :disabled="disabled || loading"
    @click="showModal = true"
  ) Diagnóstico imposible

  SamtekModal(
    v-model="showModal"
    :title="modalTitle"
    :confirmText="loading ? 'Procesando ...' : 'Sí, rechazar OT'"
    cancelText="Cancelar"
    :loading="loading"
    @confirm="handleConfirm"
    @cancel="handleCancel"
  )
    .text-center.mb-3
      b-icon(icon="exclamation-triangle-fill" font-scale="3.5" style="color: #dc3545")

    p
      | Estás a punto de cerrar esta Orden de Trabajo 
      strong Nº{{ ot.ot }}
      |  debido a que algunos repuestos necesarios están descontinuados.

    p.mt-3 Al confirmar esta acción:

    ul
      li
        | La OT pasará a estado 
        strong Rechazado
        | .
      li El cobro por revisión quedará sin costo (condonado) para el cliente.

    p.mt-3
      strong Importante
      | : Esta acción es irreversible y no se puede deshacer.
</template>

<script>
import { mapActions } from 'vuex'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'

export default {
  name: 'ActionDiagnosticoImposible',
  components: {
    SamtekModal: () => import('@/components/Common/SamtekModal.vue'),
  },
  mixins: [LoadingButtonMixin],
  props: ['ot', 'disabled'],
  data() {
    return {
      showModal: false,
      modalTitle: '¿Declarar "Diagnóstico imposible"?',
    }
  },
  methods: {
    ...mapActions('OTStore', ['diagnosticoImposible']),

    handleCancel() {
      this.showModal = false
    },

    async handleConfirm() {
      try {
        await this.executeWithLoading(async () => {
          const response = await this.diagnosticoImposible({ otId: this.ot.ot })
          if (response && response.status >= 400) {
            this.$bvToast.toast(
              response.data?.error || 'Error al ejecutar la acción',
              { title: 'Error', variant: 'danger', solid: true }
            )
            return
          }
          this.$bvToast.toast('OT rechazada por diagnóstico imposible.', {
            title: 'Éxito',
            variant: 'success',
            solid: true,
          })
          this.showModal = false
          this.$emit('changed')
        })
      } catch (error) {
        console.error('Error al ejecutar diagnóstico imposible:', error)
        this.$bvToast.toast('Error al ejecutar la acción.', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      }
    },
  },
}
</script>
